import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-108">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-109" />

      <div className="relative w-full max-w-3xl max-h-[90vh] bg-[#1a1a1a] border border-brand-amber/20 rounded-2xl shadow-2xl flex flex-col" data-id="element-110">
        <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-111">
          <h2 className="text-2xl font-serif font-bold text-brand-offwhite" data-id="element-112">
            Políticas de Privacidad
          </h2>
          <button onClick={onClose} className="p-2 text-brand-offwhite/50 hover:text-brand-offwhite hover:bg-white/5 rounded-full transition-colors" data-id="element-113">
            <X className="w-5 h-5" data-id="element-114" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto custom-scrollbar text-brand-offwhite/80 space-y-6 text-sm leading-relaxed" data-id="element-115">
          <section data-id="element-116">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-117">
              1. Información General
            </h3>
            <p data-id="element-118">
              En "Después del Engaño", valoramos y respetamos profundamente su
              privacidad. Entendemos la naturaleza sensible del tema que
              tratamos y nos comprometemos a proteger su información personal
              con los más altos estándares de seguridad y confidencialidad.
            </p>
          </section>

          <section data-id="element-119">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-120">
              2. Información que Recopilamos
            </h3>
            <p data-id="element-121">
              Para procesar su compra y entregarle el producto digital,
              recopilamos únicamente la información estrictamente necesaria:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-122">
              <li data-id="element-123">Nombre (opcional o seudónimo permitido)</li>
              <li data-id="element-124">
                Dirección de correo electrónico (para enviar el acceso al
                producto)
              </li>
              <li data-id="element-125">
                Información de pago (procesada de forma segura por nuestros
                proveedores, nosotros no almacenamos los datos de su tarjeta)
              </li>
            </ul>
          </section>

          <section data-id="element-126">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-127">
              3. Uso de la Información
            </h3>
            <p data-id="element-128">Utilizamos su información exclusivamente para:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-129">
              <li data-id="element-130">Procesar su pago de $6.36 USD.</li>
              <li data-id="element-131">Entregarle el acceso al producto digital.</li>
              <li data-id="element-132">Proporcionar soporte técnico si lo requiere.</li>
              <li data-id="element-133">Enviar actualizaciones importantes sobre su compra.</li>
            </ul>
          </section>

          <section data-id="element-134">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-135">
              4. Discreción y Confidencialidad
            </h3>
            <p data-id="element-136">Garantizamos absoluta discreción en su compra:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-137">
              <li data-id="element-138">
                El cargo en su estado de cuenta bancario aparecerá bajo un
                nombre genérico y discreto, sin mencionar palabras relacionadas
                con infidelidad o terapia.
              </li>
              <li data-id="element-139">
                No enviaremos correos electrónicos promocionales no solicitados
                a su bandeja de entrada.
              </li>
              <li data-id="element-140">
                No compartimos, vendemos ni alquilamos su información personal a
                terceros bajo ninguna circunstancia.
              </li>
            </ul>
          </section>

          <section data-id="element-141">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-142">
              5. Seguridad de los Datos
            </h3>
            <p data-id="element-143">
              Implementamos medidas de seguridad estándar de la industria para
              proteger su información contra acceso no autorizado, alteración,
              divulgación o destrucción. Todas las transacciones se realizan a
              través de conexiones encriptadas (SSL).
            </p>
          </section>

          <section data-id="element-144">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-145">
              6. Sus Derechos
            </h3>
            <p data-id="element-146">
              Usted tiene derecho a solicitar la eliminación de sus datos de
              nuestros registros en cualquier momento después de haber recibido
              su producto. Para ejercer este derecho, por favor contáctenos a
              través de nuestro canal de soporte.
            </p>
          </section>
        </div>
      </div>
    </div>;
}